<template>
  <v-dialog
    v-model="useErrors.visible"
    persistent
    max-width="500"
    :transition="false"
    scrollable
  >
    <v-card>
      <v-card-title>
        <v-alert dense shaped type="error" transition="scale-transition">{{
          t("api-error-api.title")
        }}</v-alert>
      </v-card-title>
      <v-card-text class="pa-5">
        <v-list>
          <v-list-item
            density="compact"
            v-for="(message, i) in useErrors?.messages || []"
            :key="`Messages${i}`"
          >
            <div
              class="text-left font-weight-bold"
              style="white-space: pre-line"
            >
              <v-icon class="mr-2">mdi-message-text</v-icon>
              {{ message.code }} - {{ message.description }}
            </div>
          </v-list-item>
        </v-list>

        <div v-if="showDetails && useErrors?.status" class="mt-5">
          <h3 class="mb-5">{{ t("api-error-api.details") }}</h3>
          <v-list-item dense>
            <div class="text-left" style="white-space: pre-line">
              <v-icon class="mr-2">mdi-api</v-icon>
              {{ useErrors?.url }}
            </div>
          </v-list-item>
          <v-list-item dense>
            <div class="text-left" style="white-space: pre-line">
              <v-icon class="mr-2">mdi-code-tags</v-icon>
              {{ useErrors?.status }}
            </div>
          </v-list-item>
          <v-list-item dense>
            <div class="text-left" style="white-space: pre-line">
              <v-icon class="mr-2">mdi-label</v-icon>
              {{ useErrors?.statusText }}
            </div>
          </v-list-item>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn small @click="showDetails = !showDetails">
          <v-icon class="mr-2">mdi-magnify</v-icon>{{ t("button.details") }}
        </v-btn>
        <v-btn small @click.stop="clearErrors">
          <v-icon class="mr-2">mdi-close</v-icon>{{ t("button.close") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { useErrors, clearErrors } from "@/store/useErrors";
import { useI18n } from "vue-i18n";

const showDetails = ref(false);
const { t } = useI18n();
</script>
<style scoped>
.v-card__title {
  background-color: red;
  color: #fff;
  justify-content: center;
}
</style>
